export const statusList = [
    {value: 'CRIADO', label: 'Criado'},
    {value: 'CANCELADO', label: 'Cancelado'},
    {value: 'PAGO', label: 'Pago'},
]